import styled from 'styled-components';

export const TableContentWrap = styled.div<{ onClick?: () => void }>`
  min-width: 30%;
  max-width: 100%;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  white-space: wrap;
  transition: background-color 0.1s linear;
  transition: border-radius 0.2s linear;
  border-radius: 8px;
  cursor: ${(props) => (props.onClick ? 'pointer' : 'inherit')};

  &:hover {
    background-color: ${({ theme }) => theme.palette.action.hover};
  }
`;
export const ContentTitle = styled.div`
  font-size: 15px;
  color: ${({ theme }) => theme.palette.primary.main};
`;

export const ContentDescription = styled.div`
  font-size: 18px;
  color: ${({ theme }) => theme.palette.text.primary};
  line-break: anywhere;
`;

export const ContentDate = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.text.secondary};
`;
